export default {
  install (Vue) {
    const sort = (x, y) => {
      if (typeof x === 'number') return x - y
      if (typeof x === 'string') {
        let tmpX = x.toLowerCase()
        let tmpY = y.toLowerCase()
        if (tmpX < tmpY) return -1
        else if (tmpX > tmpY) return 1
        else return 0
      }
    }
    Vue.sort = Vue.prototype.$sort = sort
  }
}
